module.exports = __webpack_public_path__ + "static/media/plus.16b2cd73.svg";